export const gpeOne = [
  {
    intro:
      "We are a group of 10 medical students returning from Tsunami relief op when we encountered 7 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take 2 minutes. We start at 1402 hrs and solve the problems as follows:",
  },
  {
    problemN: 1,
    problem: "Helping boy getting conscious: ",
    solution:
      "We will provide first aid and water to the boy and get him conscious. ",
  },
  {
    problemN: 2,
    problem: "Finding girl-friends and reporting to police:",
    solution:
      "Two of us will take vehicle available in village A and go towards the police station, inform them about our friend being abducted and will go along with police to the Village to help in tracing and arresting the gundas. Help girl-friends, calm them and take care of them  ",
    distance: "12-13 km(to and fro) ",
    time: "25-30 minutes",
  },
  {
    problemN: 3,
    problem: "Rescuing people from helicopter:",
    solution:
      "Two of us will take another vehicle from the village and head towards the site where helicopter crash-landed and with help of nearby people, evacuate them safely and check and treat them for injuries. ",
    distance: "7-8 km",
    time: "15-20 minutes ",
  },
  {
    problemN: 4,
    problem: "Rescuing people from school building:",
    solution:
      "After calling the fire brigade, three of us will rush towards the school building, help in evacuating the ladies and children from the building, and try to extinguish the fire until the fire brigade arrives.   ",
  },
  {
    problemN: 5,
    problem: "Motivating relief personnel to continue working in village B:",
    solution:
      "We will inform our superiors and also motivate the relief personnel not to leave the village as it was the time that they are needed the most. Also, request superiors to have a change of shifts at least twice daily for all personnel.  ",
  },
  {
    problemN: 6,
    problem: "Reporting police about Village C:",
    solution:
      "The two of us that reached police station will also inform about village C and sufficient police personnel will tackle the hardened criminals and control situation.",
  },
  {
    problemN: 7,
    problem: "Rescuing the dog:",
    solution:
      "One of us will go the with boy and help in rescuing his pet dog from the damaged house.",
  },
  {
    final: "Finally, all 10 of us will meet and reach Hostel before 1800 hrs ",
  },
];

export const gpeTwo = [
  {
    intro:
      "We are a group of 6 NCC Cadets returning from COVID duty when we encountered 5 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take 2 minutes. We start off 1302 hrs and solve the problems as follows: ",
  },
  {
    problemN: 1,
    problem: "Saving driver of the vehicle involved in the accident:",
    solution:
      "We will give first aid to the badly injured driver and will transport him immediately to the primary health center nearby in our minivan. Two of us will stay back in the PHC and meanwhile others will inform police about the bank robbery and the factory. We will also inform our CO about the situation ",
    distance: "20 km ",
    time: "20-25 minutes ",
  },
  {
    problemN: 2,
    problem: "Getting friend checked and treated:",
    solution:
      "We will carry our friend in the minivan as well and get him tested for COVID at the PHC.",
    distance: "20 km ",
    time: "20-25 minutes ",
  },
  {
    problemN: 3,
    problem: "Preventing bank robbery:",
    solution:
      "Four of us will take the minivan towards Kotla Village, alert villagers about the bank robbery, and help in guarding the bank, overpower the robbers and catch them with the help of villagers and hand them over to the police.",
    distance: "20 km ",
    time: "20 minutes ",
  },
  {
    problemN: 4,
    problem: "Helping child and reporting rubber factory to police:",
    solution:
      "We will take the child with us in the minivan, calm him down and go to the factory and help police in catching the owner red-handed and rescue the children, and close the factory. ",
    distance: "20 km ",
    time: "20-30 minutes ",
  },
  {
    problemN: 5,
    problem: "Delivering Food Packets:",
    solution: "We will deliver food packets when we reach Kotla Village.  ",
  },
  {
    final:
      "Finally, all 6 of us will meet at Milestone 44 and reach unit before 1630 hrs ",
  },
];

export const gpeThree = [
  {
    intro:
      "We are a group of 8 students headed back to college from Kali Lake to attend Inter College Musical Night when we encounter 5 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take around 5-10 minutes. We start at 3:15 PM and solve the problems as follows:  ",
  },
  {
    problemN: 1,
    problem: "Saving drowning couple:",
    solution:
      "Two boys will take another boat and rush towards the drowning boat and rescue the couple and bring them back to the shore",

    time: "10-15 minutes",
  },
  {
    problemN: 2,
    problem: "Treating injured forest guard:",
    solution:
      "While the couple is being rescued rest of us will take first aid kit from our van, and stop the forest guard’s bleeding with cotton and Dettol, give him water, and would take him in the van towards the Primary Health Centre near railway bridge for further treatment where two boys will stay with him and meanwhile inform Police about the incident.",
    distance: " 18 km ",
    time: "50-60 minutes",
  },
  {
    problemN: 3,
    problem: "Preventing looting of passenger train:",
    solution:
      "Two boys will deboard the van near Railway Station and go on foot towards the station and inform the Railway Police about the planned looting of train at 4:30 PM near the Betwa Bridge and accompany them in intercepting and catching the dacoits. ",
    distance: "12 km ",
    time: "35-40 minutes ",
  },
  {
    problemN: 4,
    problem: "Preventing dacoity and smuggling of Siva idol:",
    solution:
      "Two boys will deboard near Kasori Forest Reserve and run towards the forest and inform the forest guards and officials about the dacoity of Siva idol from temple and presence of smugglers in the Forest.  ",
    distance: "6 km  ",
    time: "20-25 minutes ",
  },
  {
    problemN: 5,
    problem: "Helping fisherman:",
    solution:
      "The two boys who saved the drowning couple will help the fisherman to retrieve his boat and later join the group before heading back to college. ",
    time: " 35-40 minutes ",
  },
  {
    final:
      "Finally, the van with 2 of us will pick up friends from Betwa Bridge, Forest Reserve, and Kali Lake and start our journey at 6:00 PM and reach college by 6:45 PM and enjoy the Musical Night. ",
  },
];

export const gpeFour = [
  {
    intro:
      "We are a group of 8 students we encounter 5 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take around 5-10 minutes. We start at 1310 hrs and solve the problems as follows:   ",
  },
  {
    problemN: 1,
    problem: "Preventing militants from looting village:",
    solution:
      "We will request guests in Rest House for car and four friends will take the car towards the railway station and inform Railway Police about the presence of militants and planned looting of village Kalsi and of the kidnapping plot of the rich person, and also inform station master about the landslide. Two friends will accompany police going towards Kalsi village and help in catching the militants and prevent looting.",
    distance: ": 5-6 km ",
    time: "10-15 minutes",
  },
  {
    problemN: 2,
    problem: "Preventing kidnapping of rich person:",
    solution:
      "Other two friends will accompany the police party going towards Tezpur to prevent the kidnapping of rich person  ",
    distance: "3-4 km ",
    time: "8-10 minutes ",
  },
  {
    problemN: 3,
    problem: "Removal of rocks from railway tracks:",
    solution:
      "The station-master has already been informed, he will stop the passenger train from Sherpur and clear out the track with the help of JCB.",
  },
  {
    problemN: 4,
    problem: "Helping to find lost monkey:",
    solution:
      "One of us will help the man trace his monkey, and will be joined by others after they finish their respective tasks.   ",
    time: "20-30 minutes ",
  },
  {
    problemN: 5,
    problem: "Repairing of mini-bus:",
    solution:
      "One of us will stay back and ensure that the mini-bus is repaired. ",
    time: " approx. 60 minutes ",
  },
  {
    final:
      "Finally, all 8 of us will meet at the rest house and take the mini-bus, and head towards Tulsi. ",
  },
];

export const gpeFive = [
  {
    intro:
      "We are a group of 6, traveling to Village B to write an exam at 2 PM. En route, we encounter 4 problems. I will divide my group into small groups of 2 each. Discussion for the plan of action will take around 5-10 minutes. We start at 1235 hrs and solve the problems as follows:  ",
  },
  {
    problemN: 1,
    problem: "Saving injured scientist:",
    solution:
      "We will apply pressure to the gunshot wound and tie cloth to prevent blood loss and give some first aid from our vehicle and two of us will take him to the Defence lab as there are trained medical staff present there to treat gunshot wounds also informing the military personnel about the handover of codes at the airstrip.",
    distance: " 3-4 km ",
    time: "10-15 minutes ",
  },
  {
    problemN: 2,
    problem: "Preventing handover and getting codes back:",
    solution:
      "As military personnel has been informed, they will take care of catching the miscreants and getting the codes back while the scientist will delay the effect.",
  },
  {
    problemN: 3,
    problem: "Rescuing boy from the island:",
    solution:
      "Two of us will request Resort Owner, ask for a motorboat, take the teacher along, and driver to the island. Quickly bring back the child before the storm approaches   ",
    distance: "2-3 km",
    time: " 15-30 minutes",
  },
  {
    problemN: 4,
    problem: "Getting the package from Village A:",
    solution:
      "After reaching Village B we will call a friend who lives in Village A and ask him to collect and bring the correct package with him and deliver it to the resort owner. ",
    distance: " 17 km ",
    time: " 18-20 minutes ",
  },
  {
    final:
      "Finally, all of us will attend the exam at 2 PM and give our best. ",
  },
];
